import { duration } from '../utils/duration';

export const inviteExpiration = duration({ hours: 12 });
export const clearInvitesAfter = duration({ days: 3 });
